import { getEmailSchema } from 'utils/schema';
import * as yup from 'yup';
import { TRegistrationFormValues } from './RegistrationForm.types';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getRegistrationSchema = (localize: TLocalize) =>
  yup.object<TRegistrationFormValues>().shape({
    email: getEmailSchema(localize).required(
      localize('validation.email.required') as string
    ),
    password: yup
      .string()
      .required(localize('validation.auth.password.required') as string)
      .min(8, localize('validation.auth.password.min') as string)
      .test(
        'has-number',
        localize('validation.auth.password.number') as string,
        (value) => {
          return value ? /\d/.test(value) : false;
        }
      )
      .test(
        'has-capital',
        localize('validation.auth.password.capital') as string,
        (value) => {
          return value ? /[A-Z]/.test(value) : false;
        }
      )
      .test(
        'has-symbol',
        localize('validation.auth.password.symbol') as string,
        (value) => {
          return value
            ? /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value)
            : false;
        }
      ),
  });
